import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { cx } from '@/lib/cx'
import { clasesBoton, type TamanoBoton, type VarianteBoton } from './clasesBoton'

export type { TamanoBoton, VarianteBoton } from './clasesBoton'

export interface BotonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VarianteBoton
  tamano?: TamanoBoton
  cargando?: boolean
}

export const Boton = forwardRef<HTMLButtonElement, BotonProps>(function Boton(
  {
    variante = 'primario',
    tamano = 'normal',
    cargando,
    disabled,
    className,
    children,
    type,
    ...resto
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      disabled={disabled || cargando}
      aria-busy={cargando || undefined}
      className={cx(clasesBoton(variante, tamano), className)}
      {...resto}
    >
      {children}
    </button>
  )
})
